import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLink, FiList, FiHeart, FiShoppingBag, FiUsers, FiCheck } = FiIcons;

const Features = () => {
  const features = [
    {
      icon: FiLink,
      title: "Import from Any Store",
      description: "Simply paste URLs from your favorite stores and we'll automatically import product details, images, and pricing.",
      color: "from-rose-primary to-rose-secondary"
    },
    {
      icon: FiHeart,
      title: "Want vs Need Lists",
      description: "Organize your items by priority. Let gifters know what you truly need versus what would be nice to have.",
      color: "from-rose-secondary to-rose-accent"
    },
    {
      icon: FiUsers,
      title: "Gifter's Choice",
      description: "Share your lists with friends and family. They can see what matters most and choose the perfect gift.",
      color: "from-rose-accent to-rose-primary"
    },
    {
      icon: FiList,
      title: "Multiple Lists",
      description: "Create separate lists for different occasions - birthdays, holidays, weddings, or just because.",
      color: "from-rose-primary to-rose-dark"
    },
    {
      icon: FiShoppingBag,
      title: "Direct Purchase Links",
      description: "Gifters can purchase directly from your list with one tap, making the buying process seamless.",
      color: "from-rose-secondary to-rose-primary"
    },
    {
      icon: FiCheck,
      title: "Real-time Updates",
      description: "See when items are purchased and avoid duplicate gifts. Keep everyone in sync automatically.",
      color: "from-rose-accent to-rose-secondary"
    }
  ];

  return (
    <section id="features" className="py-20 px-6 bg-white/50">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-rose-primary to-rose-secondary bg-clip-text text-transparent">
              Features That Make
            </span>
            <br />
            <span className="text-gray-800">Gift Giving Perfect</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Everything you need to create, share, and manage the perfect gift list experience.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-rose-primary/10"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-2xl flex items-center justify-center mb-6 shadow-lg`}>
                <SafeIcon icon={feature.icon} className="text-white text-2xl" />
              </div>
              
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;